module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day03_05_stay-8beb0a6d708c7d94d57d406032703920.jpg";